/**
 * Инкапсулирует параметры постраничной навигации.
 */
export class Page {
    private static DEFAULT_OFFSET = 0;

    private static DEFAULT_COUNT = 20;

    /**
     * Смещение относительно начала набора данных. Начиная с 0.
     */
    readonly offset: number;

    /**
     * Максимальное количество возвращаемых элементов. Значение > 0;
     */
    readonly count: number;

    constructor(offset: number, count: number) {
        this.offset = offset;
        this.count = count;
    }

    /**
     * Получить страницу по умолчанию
     */
    static first() {
        return new Page(Page.DEFAULT_OFFSET, Page.DEFAULT_COUNT);
    }
}
